import type { PriceLadderValidation, SizeLadderValidation } from "@ppb/bet-engine";
import type { ExchangeBettingState } from "./ExchangeBetting.types";
import type { ExchangeSide, URN } from "../../../types";

export const BETTING__EXC_STATE_UPDATE = "BETTING/EXC_STATE_UPDATE";

export type BettingExchangeStateUpdatedAction = {
  type: typeof BETTING__EXC_STATE_UPDATE;
  payload: {
    state: ExchangeBettingState;
  };
};

export const BETTING__UPDATE_UNMATCHED_BET_ACTION = "BETTING/UPDATE_UNMATCHED_BET_ACTION";

export type UpdateUnmatchedBetAction = {
  type: typeof BETTING__UPDATE_UNMATCHED_BET_ACTION;
  payload: {
    runner: URN;
    betId: string;
    price?: number;
    size?: number;
    side: ExchangeSide;
  };
};

export const BETTING__NUDGE_UP_UNMATCHED_BET_ACTION = "BETTING/NUDGE_UP_UNMATCHED_BET_ACTION";

export type NudgeUpUnmatchedBetAction = {
  type: typeof BETTING__NUDGE_UP_UNMATCHED_BET_ACTION;
  payload: {
    runner: URN;
    betId: string;
    input: "size" | "price";
  };
};

export const BETTING__NUDGE_DOWN_UNMATCHED_BET_ACTION = "BETTING/NUDGE_DOWN_UNMATCHED_BET_ACTION";

export type NudgeDownUnmatchedBetAction = {
  type: typeof BETTING__NUDGE_DOWN_UNMATCHED_BET_ACTION;
  payload: {
    runner: URN;
    betId: string;
    input: "size" | "price";
  };
};

export const BETTING__VALID_UPDATE_UNMATCHED_BET_ACTION = "BETTING/VALID_UPDATE_UNMATCHED_BET_ACTION";

export type ValidUpdateUnmatchedBetAction = {
  type: typeof BETTING__VALID_UPDATE_UNMATCHED_BET_ACTION;
  payload: {
    betId: string;
    order: {
      price?: number;
      size?: number;
    };
  };
};

export const BETTING__INVALID_UPDATE_UNMATCHED_BET_ACTION = "BETTING/INVALID_UPDATE_UNMATCHED_BET_ACTION";

export type InvalidUpdateUnmatchedBetAction = {
  type: typeof BETTING__INVALID_UPDATE_UNMATCHED_BET_ACTION;
  payload: {
    betId: string;
    order?: {
      price?: number;
      size?: number;
      validations: {
        price?: PriceLadderValidation;
        size?: SizeLadderValidation;
      };
    };
  };
};
